import { Link } from "react-router-dom";

const Loader = ({ text = "Loading..." }) => {
    return (
        <div className="flex items-center gap-2">
            <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
            <span className="text-xs">{text}</span>
        </div>
    );
};

export const LinkButton = ({
    to,
    icon: Icon,
    className = "",
    title = "",
    loading = false,
    loadingText = "Loading...",
}) => {
    return (
        <div className="relative group">
            <Link
                to={to}
                className={`
                    flex items-center justify-center
                    w-9 h-9
                    rounded-lg
                    transition-all duration-200
                    ${loading ? "opacity-60 pointer-events-none" : ""}
                    ${className}
                `}
            >
                {loading ? (
                    <Loader text={loadingText} />
                ) : (
                    Icon && <Icon size={18} />
                )}
            </Link>

            {title && !loading && <ToolTip title={title} />}
        </div>
    );
};

export const Button = ({
    onClick,
    icon: Icon,
    className = "",
    disabled = false,
    title = "",
    type="button",
    loading = false,
    loadingText = "Loading...",
    children
}) => {
    return (
        <div className="relative group inline-block">
            <button
                onClick={onClick}
                type={type}
                disabled={disabled || loading}
                className={`
                    flex items-center justify-center gap-2
                    px-4 py-2
                    rounded-lg
                    whitespace-nowrap
                    transition-all duration-200
                    ${loading ? "opacity-60 cursor-not-allowed" : ""}
                    ${className}
                `}
            >
                {loading ? (
                    <>
                        <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                        <span>{loadingText}</span>
                    </>
                ) : (
                    <>
                        {Icon && <Icon size={16} className="shrink-0" />}
                        {children}
                    </>
                )}
            </button>

            {title && !loading && <ToolTip title={title} />}
        </div>
    );
};

const ToolTip = ({ title }) => {
    return (
        <span
            className="absolute -top-9 left-1/2 -translate-x-1/2 
            scale-0 group-hover:scale-100 transition-all duration-200
            bg-gray-900 text-white text-xs px-2 py-1 rounded-md shadow whitespace-nowrap"
        >
            {title}
        </span>
    );
};